import { LOCATION_TYPE } from '../type';

const initialState = {
  SeatList: [],
  loader: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case LOCATION_TYPE:
      return {
        ...state,
        SeatList: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
